export const ACCEPTANCE_LETTER_UPLOAD_REQUIREMENT_FIELD =
  'acceptance_letter_upload_requirement';

export const ACCEPTANCE_LETTER_UPLOAD_REQUIREMENT_MAP = {
  ALL_COLLEGES: 'accepted_and_enrolled_colleges',
  ENROLLED_COLLEGES: 'enrolled_colleges_only',
  DISABLED: 'disabled',
};

export const CEEB_CODE_VARIANT = 'ceeb';
export const SCHOOL_CONTACT_VARIANT = 'schoolContact';
export const TRANSCRIPT_CONTACT_VARIANT = 'transcriptContact';

export const ACCEPTANCE_LETTER_OPTIONS = [
  {
    value: ACCEPTANCE_LETTER_UPLOAD_REQUIREMENT_MAP.ALL_COLLEGES,
    label: 'Require for all accepted colleges',
  },
  {
    value: ACCEPTANCE_LETTER_UPLOAD_REQUIREMENT_MAP.ENROLLED_COLLEGES,
    label: 'Require for enrollment decision college only',
  },
];

export const SCHOOL_PROFILE_PDF_SIZE_LIMIT_IN_MB = 2;
